import React from 'react';
import PropTypes from 'prop-types';
import TextField from 'material-ui/TextField';

const RenderTextInputField = (props) => {
    const {
        className,
        defaultValue,
        disabled,
        floatingLabelFixed,
        fullWidth,
        input: {
            name,
            onBlur,
            onChange,
            onFocus,
            value,
        },
        label,
        meta: { touched, error },
        placeholder,
        style,
        type,
        ...otherProps
    } = props;

    return (
        <TextField
            className={ className }
            defaultValue={ defaultValue }
            disabled={ disabled }
            errorText={ touched && error }
            floatingLabelFixed={ floatingLabelFixed }
            floatingLabelText={ label }
            fullWidth={ fullWidth }
            hintText={ placeholder }
            id={ name }
            onBlur={ onBlur }
            onChange={ onChange }
            onFocus={ onFocus }
            style={ style }
            type={ type }
            value={ value }
            { ...otherProps }
        />
    );
};

RenderTextInputField.defaultProps = {
    floatingLabelFixed: false,
    fullWidth: false,
    type: 'text',
};

RenderTextInputField.propTypes = {
    className: PropTypes.string,
    defaultValue: PropTypes.string,
    disabled: PropTypes.bool,
    floatingLabelFixed: PropTypes.bool,
    fullWidth: PropTypes.bool,
    input: PropTypes.shape({
        name: PropTypes.string.isRequired,
        onBlur: PropTypes.func,
        onChange: PropTypes.func,
        onDragStart: PropTypes.func,
        onDrop: PropTypes.func,
        onFocus: PropTypes.func,
        value: PropTypes.value,
    }).isRequired,
    label: PropTypes.string.isRequired,
    meta: PropTypes.shape({
        error: PropTypes.oneOfType([
            PropTypes.func,
            PropTypes.string,
        ]),
        touched: PropTypes.bool,
    }),
    placeholder: PropTypes.string,
    style: PropTypes.object,
    type: PropTypes.string,
    value: PropTypes.string,
};

export default RenderTextInputField;



// WEBPACK FOOTER //
// ./src/components/form/InputFields/RenderTextInputField.js